// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Assuming you have router setup


const app = createApp(App)

// Make sure Vue Router/Store are used before mounting
if (router) {
  app.use(router)
}

app.mount('#erc-vehicle-catalogue-app') // Ensure this matches your mount point
